import BaseRegulation from '../base_regulation';
import Device from '../../../../utils/device';
import {CyClass} from "../../../../../../common/cy-classes";
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import { GNWP_SOURCES } from '../../../../components/external_links/external_links_consts';

class ItalyRegulation extends BaseRegulation {

	static CLASS = 'ItalyRegulation';


	/**
	 *
	 * @param params
	 */
	init(params) {
		super.init(params);
		this._tempAccountMessageHelper = params.tempAccountMessageHelper || TempAccountMessageRegulationHelper.create({
			serviceFactory: this.serviceFactory
		});
	}

	_tempAccountMessageHelper;

	showTempAccountMessage(closeFunc) {
        this._tempAccountMessageHelper.showTempAccountMessage({
			closeFunc: closeFunc,
			messageKey: 'it_temp_account_message',
			footerMessageKey: 'it_temp_account_footer_message',
			titleKey: 'temp_account_title',
			btnNameKey: 'temp_account_upload_btn'
		});
	}

	getExternalLinksConfig() {
        return {
            'upload_document': {
                isCloseBtnAllowed: false
            }
        };
    }

    getTempAccountGnwpSource() {
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

	forceIntermediatePageForAutorizedUsers() {
		return false;
	}

	getHistoryHeaderRows(historyData) {
		let langService = this.serviceFactory.languageService();

		return Device.isMobile() ? [
			{
				classList: ['cgp-no-border-bottom'],
				data: {
					gameName: {
						data: historyData && historyData.gameSession && historyData.gameSession.title,
						classList: ['cgp-game-name', CyClass('cy-gaming-history-game-name'), 'cgp-themes-small-text', 'cgp-theme-property-color-base01']
					}
				}
			},
			{
				classList: ['cgp-aams-info-table-header-mobile'],
				data: {
					sessionID: {
						data: langService.translation('game_window_sessionid', {sessionID: historyData.AdditionalData.AAMSGameSessionID}),
						classList: ['cgp-game-details-table-header-gameid', 'cgp-themes-small-secondary-text', 'cgp-theme-property-color-base02', CyClass('cy-gaming-history-session-id')]
					},
					participationID: {
						data: langService.translation('game_participation_id', {participationID: historyData.AdditionalData.AAMSParticipationTicketID}),
						classList: ['cgp-game-details-table-header-participationid', 'cgp-themes-small-secondary-text', 'cgp-theme-property-color-base02', CyClass('cy-gaming-history-participation-id')]
					}
				}
			}] : [{
				classList: [],
				data: {
					gameName: {
						data: historyData && historyData.gameSession && historyData.gameSession.title,
						classList: ['cgp-game-name', 'cgp-themes-large-text', CyClass('cy-gaming-history-game-name')]
					},
					sessionID: {
						data: langService.translation('game_window_sessionid', {sessionID: historyData.AdditionalData.AAMSGameSessionID}),
						classList: ['cgp-game-details-table-header-gameid', 'cgp-themes-main-text', 'cgp-theme-property-color-base02', CyClass('cy-gaming-history-session-id')]
					},
					participationID: {
						data: langService.translation('game_participation_id', {participationID: historyData.AdditionalData.AAMSParticipationTicketID}),
						classList: ['cgp-game-details-table-header-participationid', 'cgp-themes-main-text', 'cgp-theme-property-color-base02', CyClass('cy-gaming-history-participation-id')]
					}
				}
		}];
	}
}

export default ItalyRegulation;
